import styled from 'styled-components';
import Link from 'next/link';

import BaseButton from '@components/Button/next';

export const Container = styled.div`
  width: 100%;
  height: auto;
  position: relative;
  overflow: hidden;
`;

export const DetailContainer = styled.div`
  background-color: ${({ theme }) => theme.palette.lynxWhite};
`;
export const Wrapper = styled.div`
  margin-left: 30px;
  margin-right: 30px;
  max-width: 1180px;
  z-index: 100;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    margin: -10px 0 0 0;
  }
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    margin-top: -6.8px;
  }
`;

export const BasketErrorText = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.black};
`;

export const PaymentStartedErrorContainer = styled.div`
  font-size: 14px;
`;

export const LinkText = styled(Link)`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.clearBlue};
  font-weight: bold;
`;

export const ImagesWrapper = styled.div`
  position: relative;
  margin-bottom: -80px;
  z-index: 0;
  object-fit: contain;
  width: 100%;
  background-color: ${({ theme }) => theme.palette.white};
  display: flex;
  justify-content: center;
  padding: 0 0 40px 0;
  margin-top: 20px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    padding-top: 0;
  }
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    margin: 0;
    padding-bottom: 0;
  }
`;

export const BreadcrumbWrapper = styled.div`
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    height: 40px;
    align-items: center;
    padding: 15px;
    display: flex;
  }
`;
export const HotelTitle = styled.h1`
  margin-top: 15px;
  margin-bottom: -5px;
`;
export const HotelTitleMobile = styled.h1`
  margin: 15px 15px -9px 15px;
`;

export const HeaderWrapper = styled.div`
  margin-bottom: 20px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    margin-bottom: 0;
  }
`;

export const BreadcrumbDesktop = styled.div`
  max-width: 1240px;
  height: auto;
  margin: 0 auto;
  margin-bottom: -10px;
  @media ${({ theme }) =>
      `(min-width: 576px ) and (max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding-left: 15px;
  }
`;

export const InfoUnavailable = styled.div`
  padding-left: 13px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const VerticalLine = styled.div`
  border-radius: 8px 0 0 8px;
  border-left: 8px solid ${({ theme }) => theme.palette.yellow};
  height: 137px;
`;
export const WrapperInfo = styled.div`
  display: flex;
  padding-right: 169px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    display: block;
    text-align: center;
    padding-left: 0px;
    padding-bottom: 10px;
    padding-right: 0px;
  }
`;
export const ColCustomIcon = styled.div`
  display: flex;
  justify-content: center;
`;
export const PhoneSpan = styled.span`
  margin-left: 5px;
`;

export const InfoContainer = styled.div`
  display: flex;
  padding: 0 0 0 40px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    display: block;
    height: auto;
    padding: 0px;
  }
`;
export const RoomWarning = styled.div`
  width: 100%;
  height: 137px;
  background-color: ${({ theme }) => theme.palette.white};
  display: inline-flex;
  align-items: center;
  padding-right: 40px;
  border-radius: 8px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    display: block;
    height: auto;
    padding: 16px;
  }
`;
export const StyledButton = styled(BaseButton)`
  width: 220px;
  font-size: 18px;
  height: 58px;
  font-weight: bold;
  gap: 2px;
  border-color: ${({ theme }) => theme.palette.black};
  background-color: ${({ theme }) => theme.palette.white};
  color: ${({ theme }) => theme.palette.black};
  :hover {
    border-color: ${({ theme }) => theme.palette.black};
    background-color: ${({ theme }) => theme.palette.white};
    color: ${({ theme }) => theme.palette.black};
    box-shadow: none !important;
  }
  :focus {
    border-color: ${({ theme }) => theme.palette.black};
    background-color: ${({ theme }) => theme.palette.white};
    color: ${({ theme }) => theme.palette.black};
    box-shadow: none !important;
  }
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
    height: 57px;
    font-size: 18px;
  }
`;
export const FooterWrapper = styled.div`
  margin-top: 80px;
`;

export const SearchBarWrapper = styled.div`
  max-width: fit-content;

  & > div {
    max-width: 1240px;
    width: 1240px;
    grid-template-columns: repeat(3, 330px) 190px;
  }
`;

export const DetailSearchBarContentWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 auto;
`;

export const DetailSearchWrapper = styled.div<{
  sticky?: boolean;
  animated: boolean;
}>`
  margin: 0 auto;
  ${({ sticky }) => `
  margin-top: ${sticky ? '0' : ' 32px'};
  padding: ${sticky ? '10px 0' : '0'};
  position: ${sticky ? 'fixed' : 'unset'};
  width: ${sticky ? '100vw' : 'fit-content'};
  `}
  z-index: 999;
  left: 0;

  top: ${({ animated }) => (animated ? '0' : '-200px')};

  transition: all 0.35s;
  display: flex;
  background-color: ${({ sticky, theme }) =>
    sticky ? theme.palette.white : 'transparent'};
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-top: 0;
  }
`;

export const HotelLocationWrapper = styled.div`
  margin: 20px 0;
`;

export const ContainerHotel = styled.div`
  height: 100%;
  margin-left: -30px;
  margin-right: 30px;
  margin-bottom: 20px;
  margin-top: 10px;
`;
export const ContainerHotelMobile = styled.div`
  height: 100%;
  margin-left: -30px;
  margin-right: 30px;
  margin-bottom: 10px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    margin-left: 0px;
    margin-right: 0px;
  }
`;
export const Title = styled.span<{ fontSize: number; margin?: number }>`
  font-size: ${({ fontSize }) => fontSize}px;
  font-weight: bold;
  margin-left: ${({ margin }) => (margin ? margin : 0)}px;
`;
export const SeoTextContainer = styled.div`
  max-width: 1240px;
  height: auto;
  margin: 0 auto;
  position: relative;
  z-index: 1;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    margin: 0;
    width: 100%;
  }
`;
